import { apiClient } from './apiClient';

type GoogleGeocodeLocation = {
  lat: number;
  lng: number;
};

type GoogleGeocodeResponse = {
  results?: Array<{
    geometry?: {
      location?: GoogleGeocodeLocation;
    };
  }>;
  status?: string;
};

export type GooglePlacePrediction = {
  description: string;
  place_id: string;
};

type GooglePlacesAutocompleteResponse = {
  predictions?: GooglePlacePrediction[];
  status?: string;
};

export async function geocodeAddress(address: string) {
  const response = await apiClient.api.google.geocode.get({
    query: { address },
  });
  if (response.error) {
    throw response.error.value;
  }
  return response.data as GoogleGeocodeResponse;
}

export async function geocodePlaceId(placeId: string) {
  const response = await apiClient.api.google.geocode.get({
    query: { placeId },
  });
  if (response.error) {
    throw response.error.value;
  }
  return response.data as GoogleGeocodeResponse;
}

export async function getPlaceAutocomplete(input: string, countryCode?: string) {
  const response = await apiClient.api.google.places.autocomplete.get({
    query: {
      input,
      ...(countryCode ? { countryCode } : {}),
    },
  });
  if (response.error) {
    throw response.error.value;
  }
  return response.data as GooglePlacesAutocompleteResponse;
}
